__turbopack_context__.v({
  "content": "GallerySlider-module-scss-module__xQZrsq__content",
  "crumbs": "GallerySlider-module-scss-module__xQZrsq__crumbs",
  "cursorImg": "GallerySlider-module-scss-module__xQZrsq__cursorImg",
  "imgNoCursor": "GallerySlider-module-scss-module__xQZrsq__imgNoCursor",
  "loader": "GallerySlider-module-scss-module__xQZrsq__loader",
  "nav": "GallerySlider-module-scss-module__xQZrsq__nav",
  "nav__counter": "GallerySlider-module-scss-module__xQZrsq__nav__counter",
  "selector": "GallerySlider-module-scss-module__xQZrsq__selector",
  "selector__active": "GallerySlider-module-scss-module__xQZrsq__selector__active",
  "selector__arrow": "GallerySlider-module-scss-module__xQZrsq__selector__arrow",
  "selector__arrow_down": "GallerySlider-module-scss-module__xQZrsq__selector__arrow_down",
  "selector__list": "GallerySlider-module-scss-module__xQZrsq__selector__list",
  "swiper": "GallerySlider-module-scss-module__xQZrsq__swiper",
  "swiperSlide": "GallerySlider-module-scss-module__xQZrsq__swiperSlide",
});
